<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Traveller Requirement</span>
            <el-button class="white-btn" size="small" @click="edit = true;editdet()">Edit</el-button>
        </template>
        <el-descriptions
            size="small"
            direction="vertical"
            :column="(enquiry.type=='Flight' || enquiry.type=='Visa') ? 7 : 8"
            border
        >
            <el-descriptions-item label="Type">{{enquiry.type}}</el-descriptions-item>
            <el-descriptions-item label="No. of Travelers">
                <span v-if="enquiry.adults && enquiry.adults>0">{{enquiry.adults}}-A </span>
                <span v-if="enquiry.childs && enquiry.childs>0">{{enquiry.childs}}-C </span>
                <span v-if="enquiry.infants && enquiry.infants>0">{{enquiry.infants}}-I </span>
            </el-descriptions-item>
            <el-descriptions-item label="Source">{{enquiry.source}}</el-descriptions-item>
            <el-descriptions-item label="Destination">{{enquiry.destinations}}</el-descriptions-item>
            <el-descriptions-item label="Duration"  v-if="enquiry.type!='Flight' "> <span v-if="enquiry.type!='Visa'"> {{enquiry.nights}}N/{{enquiry.nights+1}}D </span> <span v-else> {{enquiry.nights}} Days </span>   </el-descriptions-item>
            <el-descriptions-item :label="enquiry.type=='Hotel' ? 'Check-In Date' : 'Departure Date'">{{enquiry.departure_date}}</el-descriptions-item>
            <el-descriptions-item v-if="enquiry.type!='Visa'" :label="enquiry.type=='Hotel' ? 'Check-Out Date' : 'Return Date'">{{enquiry.return_date}}</el-descriptions-item>
            <el-descriptions-item label="Budget">{{enquiry.budget}}</el-descriptions-item>
            <el-descriptions-item  label="Services Includes" :span="8">
                <el-tag class="mr-2" type="info" v-for="ser in enquiry.serviceincludes">{{ser}}</el-tag>

            </el-descriptions-item>

            <el-descriptions-item label="Specific Requirements" :span="8">
                <specific-requirements-display :text="enquiry.specific_requirements"></specific-requirements-display>
            </el-descriptions-item>


        </el-descriptions>
    </el-card>



    <el-drawer size="50%" v-model="edit" direction="rtl">
        <template #header>
            <h4>Edit Traveller Detail</h4>
        </template>
        <template #default>
            <el-form
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >
                <el-radio-group v-model="form.type" @change="typechange()">
                    <el-radio label="Package">Package</el-radio>
                    <el-radio label="Hotel">Hotel</el-radio>
                    <el-radio label="Flight">Flight</el-radio>
                    <el-radio label="Visa">Visa</el-radio>
                    <el-radio label="Cruise">Cruise</el-radio>
                </el-radio-group>

                <el-row :gutter="20">
                    <el-col :span="8" v-if="form.type!='Flight'">
                        <el-form-item :label="form.type=='Visa' ? 'Days' : 'Nights'" prop="nights">
                            <el-input-number v-model="form.nights" :min="0" @change="dchange()" placeholder="Nights" />

                        </el-form-item>

                    </el-col>
                    <el-col :span="8">

                        <el-form-item :label="form.type=='Hotel' ? 'Check-In Date' : 'Departure Date'"  prop="departure_date">
                            <el-date-picker
                                @change="dchange()"
                                v-model="form.departure_date"
                                type="date"
                                placeholder="Departure Date"
                                format="DD-MM-YYYY"
                                value-format="DD-MM-YYYY"
                            />

                        </el-form-item>
                    </el-col>
                    <el-col :span="8" v-if="form.type!='Visa'">

                        <el-form-item :label="form.type=='Hotel' ? 'Check-Out Date' : 'Return Date'" prop="return_date">
                            <el-date-picker
                                :readonly="form.type=='Flight'? false : true"
                                v-model="form.return_date"
                                type="date"
                                placeholder="Return Date"
                                format="DD-MM-YYYY"
                                value-format="DD-MM-YYYY"
                            />

                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="Adults" prop="adults">
                            <el-input-number  v-model="form.adults" :min="0" placeholder="Adults" />

                        </el-form-item>

                    </el-col>
                    <el-col :span="6">

                        <el-form-item label="Childs" prop="childs">
                            <el-input-number  v-model="form.childs" :min="0" placeholder="Childs" />

                        </el-form-item>
                    </el-col>
                    <el-col :span="6">

                        <el-form-item label="Infants" prop="infants">
                            <el-input-number   v-model="form.infants" :min="0" placeholder="Infants" />

                        </el-form-item>
                    </el-col>

                    <el-col :span="6">

                        <el-form-item label="Destination Type" prop="flight.visa.dest_team">
                            <el-select-v2 v-model="form.dest_team"   :options="destinationtypes"  placeholder="Select"  style="width:100%" >

                            </el-select-v2>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-form-item label="Source" prop="source" v-if="form.type!='Flight'">
                    <el-input  v-model="form.source" placeholder="Source" />

                </el-form-item>
                <el-form-item label="Source" prop="source" v-else>
                    <airport-search   v-model="form.source"   ></airport-search>

                </el-form-item>
                <el-form-item label="Destinations" prop="destinations" v-if="form.type!='Flight'">

                    <el-select-v2 v-model="form.destinations" filterable allow-create :options="destinations" multiple placeholder="Select"  style="width:100%" >

                    </el-select-v2>
                </el-form-item>
                <el-form-item label="Destination" prop="destination" v-else>
                    <airport-search   v-model="form.destinations"   ></airport-search>

                </el-form-item>


                <el-form-item   label="Services Required" prop="packageservices">
                    <el-checkbox-group v-model="form.packageservices">
                        <el-checkbox v-for="ser in packageservicesl()" :label="ser" :disabled="this.form.type==ser" />
                    </el-checkbox-group>


                </el-form-item>
                <el-form-item  label="Specific Requirements" prop="specific_requirements">
                    <el-input type="textarea"  v-model="form.specific_requirements" :rows="5"  ></el-input>
                </el-form-item>

            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="edit=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Save</el-button>
            </div>
        </template>
    </el-drawer>
</template>

<script>
import {
    ElCheckbox,ElCheckboxGroup,ElDatePicker,ElSelectV2,ElInputNumber,ElRadioGroup,ElRadio,ElDescriptionsItem,ElDescriptions,ElCard,ElTag,ElRow,ElCol,ElButton,ElDrawer,ElForm,ElFormItem,ElInput,ElSelect,ElOption
} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'
import moment from "moment";
import SpecificRequirementsDisplay from "./SpecificRequirementsDisplay.vue";
import AirportSearch from "../../Common/AirportSearch";
export default {
    name: "TravellerRequirement",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { SpecificRequirementsDisplay, AirportSearch,ElCheckbox,ElCheckboxGroup,ElDatePicker,ElSelectV2,ElInputNumber,ElRadioGroup,ElRadio,ElDescriptionsItem,ElDescriptions,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,Edit,ElDrawer,ElForm,ElFormItem,ElInput },
    data() {
        return {
            loading:false,
            edit:false,
            states:[],
            cities:[],
            destinations:[],
            destinationtypes:[{
                value: "Domestic",
                label: "Domestic",
            },
                {
                    value: "International",
                    label: "International",
                }
                ],
            packageservices:["Land Package", "Hotel", "Flight", "Visa", "Cruise", "Travel Insurance"],
            services:[],
            form:{
                type:'',
                nights:'',
                departure_date:'',
                return_date:'',
                adults:'',
                childs:'',
                infants:'',
                source:'',
                destinations:'',
                dest_team:'',
                packageservices:[],
                specific_requirements:''
            },
            rules:{
                destinationtypes: [
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                mobile: [
                    {
                        required: true, message: 'Invalid Number',
                        trigger: ['blur','change'],
                    }
                ],
                email_id:[
                    {
                        required: true,
                        message: 'Required',
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: 'Please input correct email address',
                        trigger: ['blur', 'change'],
                    }
                ]
            }
        }
    },
    created(){
        this.getdestinations();


    },
    methods:{
        typechange(){
            if(this.form.type=="Flight"){
                this.form.packageservices= ["Flight"];
            }
            else if(this.form.type=="Hotel"){
                this.form.packageservices= ["Hotel"];
            }
            else if(this.form.type=="Visa"){
                this.form.packageservices= ["Visa"];
            }
            else if(this.form.type=="Cruise"){
                this.form.packageservices= ["Cruise"];
            }
            else{
                this.form.packageservices=  [];
            }
        },
        packageservicesl(){

            if(this.form.type=="Flight"){
                return ["Flight", "Travel Insurance"];
            }
            else if(this.form.type=="Hotel"){
                return ["Hotel", "Travel Insurance"];
            }
            else if(this.form.type=="Visa"){
                return ["Visa", "Travel Insurance"];
            }
            else if(this.form.type=="Cruise"){
                return ["Cruise", "Travel Insurance"];
            }
            else{
                return  ["Land Package", "Hotel", "Flight", "Visa", "Cruise", "Travel Insurance"];
            }

        },
        dchange(){
            if(this.form.type!="Flight" && this.form.type!="Visa"){
                if(this.form.departure_date!="" && this.form.nights!=""){
                    let start = moment(this.form.departure_date, "DD-MM-YYYY");
                    this.form.return_date=start.add(this.form.nights, 'days').format("DD-MM-YYYY");
                }
                else{
                    this.form.return_date='';
                }
            }

        },
        getdestinations(){
            let currentObj = this;
            axios.get('/alldestinations').then(function (response) {
                currentObj.destinations=response.data;
                if(currentObj.enquiry.type!="Flight"){
                    const selld=currentObj.enquiry.destinations.split(",").map((item) => {
                        return { value: item, label: item }
                    });
                    currentObj.destinations=currentObj.destinations.concat(selld)
                }


            })
                .catch(function (error) {

                });
        },
        editdet(){
            this.form.type=this.enquiry.type;
            this.form.nights=this.enquiry.nights;
            this.form.departure_date=this.enquiry.departure_date;
            this.form.return_date=this.enquiry.return_date;
            this.form.adults=this.enquiry.adults;
            this.form.childs=this.enquiry.childs;
            this.form.infants=this.enquiry.infants;
            this.form.source=this.enquiry.source;
            if(this.enquiry.type!="Flight") {
                this.form.destinations = this.enquiry.destinations.split(",");
            }
            else{
                this.form.destinations = this.enquiry.destinations;
            }
            this.form.packageservices=this.enquiry.serviceincludes;
            this.form.dest_team=this.enquiry.dest_team;
            this.form.specific_requirements=this.enquiry.specific_requirements;


        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.save()
                } else {
                    return false
                }
            })


        },
        save(){
            let currentObj = this;
            this.loading=true;
            axios.post('/saveenquirytravdetails?id='+this.enquiry.id,this.form).then(function (response) {


                toastr.success('Enquiry Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.loading=false;
                currentObj.edit=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                    toastr.error('Something Wrong try again.');
                });
        }
    }
}
</script>

<style scoped>

</style>
